var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileUser = function SvgProfileUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.837c1.456.731 2.704 1.905 3.615 3.373.18.29.27.436.302.637.063.409-.216.911-.597 1.073-.188.08-.398.08-.82.08M28 23.532a4.5 4.5 0 0 0 0-8.064M26 19.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.56 30.938C16.152 28.545 18.67 27 21.5 27s5.346 1.545 6.94 3.938c.35.525.524.787.504 1.122-.015.26-.186.58-.395.738-.267.202-.635.202-1.372.202H15.822c-.736 0-1.104 0-1.372-.202a1.108 1.108 0 0 1-.395-.738c-.02-.335.155-.597.504-1.122Z",
    stroke: "#4A49BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProfileUser;